import React from 'react';
import './styles.scss';

const ProgressBar = ({completedCount, totalCount, currentLabel}) => {
	const parsedCompletedCount = Number(completedCount);
	const parsedTotalCount = Number(totalCount);
	const safeTotalCount =
		Number.isFinite(parsedTotalCount) && parsedTotalCount > 0
			? parsedTotalCount
			: 0;
	const safeCompletedCount = Number.isFinite(parsedCompletedCount)
		? parsedCompletedCount
		: 0;
	const boundedCompletedCount = Math.min(
		Math.max(safeCompletedCount, 0),
		safeTotalCount
	);
	const percentage = safeTotalCount
		? (boundedCompletedCount / safeTotalCount) * 100
		: 0;
	const label = `Deltest ${boundedCompletedCount} av ${safeTotalCount}${
		currentLabel ? `: ${currentLabel}` : ''
	}`;

	return (
		<div
			className="screening-progress"
			role="progressbar"
			aria-label={label}
			aria-valuemin="0"
			aria-valuemax={safeTotalCount}
			aria-valuenow={boundedCompletedCount}
		>
			<div className="screening-progress__top">
				<span className="screening-progress__label">{label}</span>
				<span className="screening-progress__percent">
					{Math.round(percentage)}%
				</span>
			</div>

			<div className="screening-progress__bar">
				<div
					className="screening-progress__fill"
					style={{width: `${percentage}%`}}
				/>
			</div>
		</div>
	);
};

export default ProgressBar;
